module.exports = __webpack_public_path__ + "img/wlpprs.3aa1a4b2.png";